// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { type MutateOptions, useMutation } from '@tanstack/react-query'

import { type Coverage } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type RemoveCoverageParam = {
  coverage_id: string
  member_updated_reason: string
}

export type CoverageMutateOptions =
  | MutateOptions<Coverage[], GrapeAPIErrorType, RemoveCoverageParam, unknown>
  | undefined

export function useRemoveCoverageFromEnrollment ({
  enrollmentId,
  memberId,
}: {
  enrollmentId: string
  memberId: string
}) {
  return useMutation<Coverage[], GrapeAPIErrorType, RemoveCoverageParam>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'delete',
        `/api/web/brokers/members/${memberId}/enrollments/${enrollmentId}/coverage`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            ...params,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      // When response is empty, grape returns 204 status code with no content.
      // Because this is not valid JSON this will throw an error if we don't handle this directly.
      if (response.statusCode === 204) {
        return []
      }
      return response.json
    },
  })
}
